import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PermissionCheckWrapper from 'utils/PermissionCheckWrapper';

import CmsSidebarTabs from 'common/components/CmsSidebarTabs';

import { WorkspaceTopbar } from './Topbar';

const BASE_CLASS_NAME = 'TopbarWithCmsSidebarTabs';
class TopbarWithCmsSidebarTabs extends Component {
    static propTypes = {
        changeCmsSidebarTab: PropTypes.func.isRequired,
        children: PropTypes.node,
        topbarClassName: PropTypes.string,
        backgroundColor: PropTypes.string,
        currentCmsSidebarTab: PropTypes.string,
        canEditEventPage: PropTypes.bool.isRequired,
    };

    static defaultProps = {
        children: null,
        topbarClassName: null,
        backgroundColor: null,
        currentCmsSidebarTab: null,
    };

    render() {
        return (
            <div className={BASE_CLASS_NAME}>
                <WorkspaceTopbar
                    className={this.props.topbarClassName}
                    backgroundColor={this.props.backgroundColor}
                    useRouterForReturn
                >
                    {this.props.children}
                </WorkspaceTopbar>
                <PermissionCheckWrapper permission={this.props.canEditEventPage}>
                    {() => (
                        <CmsSidebarTabs
                            className={`${BASE_CLASS_NAME}__sidebar_tabs`}
                            currentTab={this.props.currentCmsSidebarTab}
                            onChange={this.props.changeCmsSidebarTab}
                        />
                    )}
                </PermissionCheckWrapper>
            </div>
        );
    }
}

export default TopbarWithCmsSidebarTabs;
